export function useDatoCtaStyles(
  ctaType: MaybeRefOrGetter<string | undefined | null>,
) {
  const ctaCssClass = computed(() => {
    return {
      'tw-bg-orange-500': toValue(ctaType) === 'primary',
      '!tw-border-orange-500 !tw-text-orange-500':
        toValue(ctaType) === 'outlined',
    }
  })

  const ctaColor = computed(() => {
    return toValue(ctaType)?.startsWith('accent') ? 'accent' : undefined
  })

  const ctaVariant = computed(() => {
    if (toValue(ctaType) === 'primary' || toValue(ctaType)?.includes('filled'))
      return 'primary'
    if (toValue(ctaType)?.includes('outlined')) return 'outlined'
    return undefined
  })

  return {
    ctaCssClass,
    ctaColor,
    ctaVariant,
  }
}
